import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'

const getNumberFromTitle = (entity: OldEntityInterface | PopupInterface) => {
  const title =
    entity.type === EntityTypeEnum.Popup ? entity.title : entity.options.title
  return parseInt(title.replace(/\D/g, ''))
}

export const getSortedPopupList = (
  entities: OldEntityInterface[] | PopupInterface[],
) => {
  return entities.sort((a, b) => getNumberFromTitle(a) - getNumberFromTitle(b))
}
